import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import images from '../../assets/images';
import type { IUpdateSecurityModalProps } from '../../types/propTypes';

const UpdateSecurityModal = ({
  isShowUpdateSecurityModal,
  handleSubmit,
  closeModal,
  showBackButton,
}: IUpdateSecurityModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal show={isShowUpdateSecurityModal} scrollable className="font-poppins update-security-modal" centered>
      <Modal.Body>
        <div className="w-100 text-center mb-3 mt-4">
          <img src={images.updateMFAInfoIcon} alt="" className="update-security-icon" />
        </div>
        <div className="update-security-header mb-3">{t('authentication.securityModal.header')}</div>
        <p className="marketing-preference-prompt px-2 mb-2">{t('authentication.securityModal.subHeader')}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn btn-primary w-100 mx-5 terms-and-condition-accept-button"
          title={t<string>('authentication.securityModal.submit')}
          onClick={handleSubmit}
        >
          {t('authentication.securityModal.submit')}
        </Button>
        {showBackButton && (
          <div className="w-100 mt-3">
            <div className="text-center">
              <a className="back-link" onClick={closeModal}>
                {t('authentication.securityModal.back')}
              </a>
            </div>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateSecurityModal;
